import { getStockModuleSetting } from "./getStockModuleSetting.api";
import { updateStockModuleSetting } from "./updateStockModuleSetting.api";

const stockModuleSettingApi = {
  getStockModuleSetting,
  updateStockModuleSetting,
};

export default stockModuleSettingApi;
